import { BrowserDynamicTestingModule } from "@angular/platform-browser-dynamic/testing";

export interface IExpiryMaster {
    Id: number,
    BatchNo: string;
    ExpiryDate: Date;
}

export class Expiry_Model implements IExpiryMaster {
    Id: number;
    BatchNo: string;
    ExpiryDate: Date;

    constructor() {
        this.Id = 0;
        this.BatchNo = "";
        this.ExpiryDate = new Date();

    }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/interface/Expiry_Master.ts